import { FunctionComponent } from "react";
import * as Styled from "./styles";
import { Close } from "../../../components/icons";
import IconButton from "../../../components/icon-button";

import { COLOR_MANIFEST_TEAL } from "../../../styles/globalStylesVariables";
import { IconHome, IconLogout, Menu } from "@manifesthhqinc/ui-library";

interface NavigationProps {
  sendClose: (...args: any) => void;
  closeNavigation: () => void;
  show: boolean;
  goToHomeScreen: () => void;
}
const Navigation: FunctionComponent<NavigationProps> = ({
  sendClose,
  closeNavigation,
  show,
  goToHomeScreen,
}: NavigationProps) => {
  return (
    <Styled.OuterWrapper $show={show}>
      <Styled.NavigationWrapper $show={show}>
        <Styled.NavigationContainer>
          <Styled.NavigationHeader>
            <IconButton name="navigation-close-button" onClick={closeNavigation} className="navigation-close-button">
              <Close />
            </IconButton>
          </Styled.NavigationHeader>
          <Styled.NavigationContent>
            <Menu
              items={[
                {
                  icon: <IconHome />,
                  children: "Home",

                  onClick: goToHomeScreen,
                },
                {
                  icon: <IconLogout />,
                  children: "Exit Manifest",
                  onClick: sendClose,
                },
              ]}
            />
            <Styled.NavigationItem></Styled.NavigationItem>
          </Styled.NavigationContent>
        </Styled.NavigationContainer>
        <Styled.NavigationIconTextContainer $color={COLOR_MANIFEST_TEAL}>
          <a href="mailto:support@usemanifest.com" className="support-link">
            support@usemanifest.com
          </a>
        </Styled.NavigationIconTextContainer>
      </Styled.NavigationWrapper>
    </Styled.OuterWrapper>
  );
};

export default Navigation;
